import { Formik } from 'formik';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { object } from 'yup';
import 'react-datepicker/dist/react-datepicker.css';
import { UI_DATE_FORMAT } from 'globalconfig/constants/static';
import { IS_ADMIN } from 'globalconfig/constants/validation';

const generateAndValidateForm = ({ initialValues, validationSchema, validateOnBlur = true, ...rest }) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema || object().shape({})}
      enableReinitialize
      validateOnBlur={validateOnBlur}
      onSubmit={() => {}}
    >
      {(props) => {
        return <Form {...props} {...rest} />;
      }}
    </Formik>
  );
};

export default generateAndValidateForm;

const Form = ({
  initialValues,
  errors,
  validateForm,
  isSubmitting,
  values,
  handleOnSubmit,
  direction,
  setFieldValue,
  setValues,
  RenderComponent,
  className,
  customProps,
  handleOnCancel,
  Styled,
  ...rest
}) => {
  const [isNotValid, setIsNotvalid] = useState(true);
  const handleEdit = (event, source) => {
    customProps.hasApiStatus && customProps.clearApiStatus && customProps.clearApiStatus();
    let value = event;
    if (source?.type === 'date') {
      value = source.isTimeNeeded ? value : moment(event).format(UI_DATE_FORMAT);
    } else if (source?.type === 'file') {
      value = event[0];
    }

    if (source?.callback) {
      source.callback({ ...source, value });
    }
    setFieldValue(source?.field, value);
  };

  useEffect(() => {
    if (isSubmitting) {
      for (let field in errors) {
        if (errors[field]) {
          const element = document.querySelector(`[name="${field}"]`);
          if (element && !rest?.avoidFocus) {
            if (!field?.toLowerCase()?.includes('date') && IS_ADMIN) {
              element.focus();
            }
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            break;
          }
        }
      }
    }
  }, [isSubmitting, errors]);

  const getFieldValues = (source, _props) => {
    const result = {};
    Object.keys(source).map((key) => {
      return (result[key] = source[key]);
    });
    if (_props) result._props = _props;
    return result;
  };

  return (
    <Styled.FormWrapper direction={direction} className={className}>
      <RenderComponent
        values={values}
        handleEdit={handleEdit}
        errors={errors}
        isNotValid={isNotValid}
        validateForm={validateForm}
        {...rest}
        onClear={() => {
          setValues({ ...initialValues });
        }}
        cancelAction={() => handleOnCancel()}
        customProps={customProps}
        submitAction={(data, _, _props = null) => {
          if (Object.keys(data).length === 0) {
            setIsNotvalid(true);
            handleOnSubmit(getFieldValues(values, _props), _);
          } else {
            setIsNotvalid(false);
          }
        }}
      />
    </Styled.FormWrapper>
  );
};
